
    import * as React from 'react';

    const Exit20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><g id="Exit_20_svg__Exit/20"><path id="Exit_20_svg__Combined Shape" fillRule="evenodd" clipRule="evenodd" d="M9.29293 10L2.64648 3.35356L3.35359 2.64645L10 9.2929L16.6465 2.64645L17.3536 3.35356L10.7071 10L17.3536 16.6465L16.6465 17.3536L10 10.7071L3.35359 17.3536L2.64648 16.6465L9.29293 10Z" /></g></svg>
        </div>
      );
    };

    Exit20.displayName = 'Exit20';

    export default Exit20;
  